/** A v4 UUID, client or server. `crypto.randomUUID` exists only in secure
 *  contexts and from Safari / iOS 15.4: the dev server is also opened over
 *  plain http from other devices (CLAUDE.md #21), and the iOS shell supports
 *  iOS 15.0. `getRandomValues` works in all of them. */
export function randomUuid(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6]! & 0x0f) | 0x40; // version 4
  b[8] = (b[8]! & 0x3f) | 0x80; // RFC 9562 variant
  const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
